<!-- Desktop -->
<div class="cs-detail--card w-100 p-1 m-auto background-color-white">
  <div class="cs-detail--title w-100 py-1">
    <span class="color-dark">{{ history?.[HistoryItem.reference] }}</span>
  </div>

  <page-cashier-history-detail-rows class="w-100" [history]="history"
    [historyItemRows]="historyItemRows"></page-cashier-history-detail-rows>

  <div class="cs-detail--button-group w-100">
    <button *ngIf="setCancelWithdrawal" class="cs-detail--button background-color-secondary" tappable
      (click)="cancelPayment()">
      <span class="cs-detail-button--text color-light"> {{ 'tCancel' | translate }} </span>
    </button>
    <button class="cs-detail--button background-color-primary" tappable (click)="close()">
      <span class="cs-detail-button--text color-light"> OK </span>
    </button>
  </div>
</div>